
  
  const CyberJson = [
  
    {
      "id": 1,
      "html_title": "intro",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "What is Cyber Security?",
          "bootstrap_title_desc": "Cybersecurity, or information security, is the practice of protecting computer systems, networks, and digital information from theft, damage, unauthorized access, and other cyber threats. It involves implementing security measures to defend against cyberattacks and ensure data integrity."
        },
        {
          "bootstrap_title_heading": "Cybe Besics",
          "bootstrap_title_desc": "What is Cyber Crime? Just like regular crime, it also exists on the Internet.\n\n1) Password attack\n2) Gift card code attack\n3) Document stolen, asking for money\n4) System attack\n5) SQL injection attack\n6) Security attack"
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 1",
          "bootstrap_title_desc": "For the first day, interns will conduct a security audit of a sample website (Visa Processing Site). Tasks include:\n1) Identifying potential vulnerabilities in login mechanisms.\n2) Checking for weak passwords and suggesting stronger policies.\n3) Researching and documenting common cyber threats relevant to online portals.\n4) Writing a report on best practices for securing user data."
        }
      ],
      "coursename": "Cyber Intro"
    },

    {
      "id": 2,
      "html_title": "Cybersecurity Internship - Day 2",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Types of Cyber Attacks",
          "bootstrap_title_desc": "Cyberattacks come in various forms, targeting individuals and organizations. Some common types include:\n\n1) Phishing - Deceptive emails or messages to steal personal information.\n2) Malware - Malicious software that damages or disrupts systems.\n3) Ransomware - Encrypts files and demands payment for access.\n4) Man-in-the-Middle Attack - Interception of data between two parties.\n5) Denial of Service (DoS) Attack - Overloading a system to make it unavailable.\n6) SQL Injection - Injecting malicious SQL queries to manipulate a database.\n7) Cross-Site Scripting (XSS) - Injecting malicious scripts into web applications."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 2",
          "bootstrap_title_desc": "For the second day, interns will focus on securing the Visa Processing Site from potential cyber threats. Tasks include:\n1) Conducting a security analysis of the login and registration system for vulnerabilities.\n2) Identifying and documenting security loopholes related to SQL Injection and XSS attacks in the Visa Processing Site.\n3) Implementing basic security measures, such as input validation and sanitization, to mitigate these threats.\n4) Writing a security report on detected vulnerabilities and proposed fixes.\n5) Using an automated vulnerability scanning tool to check the Visa Processing Site and document findings."
        }
      ],
      "coursename": "Cyber attacks"
    },


    {
      "id": 3,
      "html_title": "Cybersecurity Internship - Day 3",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Web Application Security Principles",
          "bootstrap_title_desc": "To secure a web application like the Visa Processing Site, it is crucial to follow key security principles:\n\n1) Least Privilege - Granting users the minimum level of access required.\n2) Defense in Depth - Implementing multiple security layers to protect data.\n3) Secure Authentication - Using strong password policies, multi-factor authentication (MFA), and session management.\n4) Data Encryption - Encrypting sensitive data at rest and in transit.\n5) Secure APIs - Protecting API endpoints from unauthorized access and data leaks."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 3",
          "bootstrap_title_desc": "On the third day, interns will work on strengthening the security of the Visa Processing Site. Tasks include:\n1) Reviewing the site's authentication and authorization mechanisms for potential weaknesses.\n2) Implementing secure password policies, including password hashing (bcrypt, Argon2, etc.).\n3) Setting up HTTPS on the local development environment and explaining its importance.\n4) Conducting a penetration test on authentication and session handling, documenting the findings.\n5) Researching best practices for securing APIs used in the Visa Processing Site and drafting recommendations."
        }
      ],
      "coursename": "Cyber security"
    },

    {
      "id": 4,
      "html_title": "Cybersecurity Internship - Day 4",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Understanding Secure Coding Practices",
          "bootstrap_title_desc": "Writing secure code is essential for protecting applications like the Visa Processing Site from cyber threats. Beginners should focus on the following key principles:\n\n1) Input Validation - Always validate and sanitize user inputs to prevent SQL Injection and Cross-Site Scripting (XSS).\n2) Secure Data Storage - Never store sensitive data in plain text; use encryption techniques.\n3) Error Handling - Avoid exposing system details in error messages.\n4) Code Reviews - Regularly review code to identify security vulnerabilities.\n5) Keeping Dependencies Updated - Use the latest security patches for frameworks and libraries."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 4",
          "bootstrap_title_desc": "For the fourth day, interns will practice secure coding techniques by improving the security of the Visa Processing Site. Tasks include:\n1) Implementing input validation on all user input fields to prevent SQL Injection and XSS.\n2) Encrypting sensitive user data, such as passwords, using bcrypt or Argon2.\n3) Implementing proper error handling to ensure that system details are not leaked.\n4) Conducting a security code review of a sample login module and identifying weaknesses.\n5) Researching and listing five best practices for maintaining secure code in web applications."
        }
      ],
      "coursename": "Cyber coding"
    },

    {
      "id": 5,
      "html_title": "Cybersecurity Internship - Day 5",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Introduction to Network Security",
          "bootstrap_title_desc": "Network security is crucial for protecting the Visa Processing Site from external threats. Key concepts include:\n\n1) Firewalls - Act as barriers to prevent unauthorized access.\n2) VPNs - Secure connections for remote access.\n3) Intrusion Detection Systems (IDS) - Monitor network traffic for suspicious activity.\n4) Secure Protocols - Use HTTPS, SSH, and TLS to encrypt data transmission.\n5) Access Control - Restrict system access based on user roles."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 5",
          "bootstrap_title_desc": "For the fifth day, interns will focus on securing the network environment of the Visa Processing Site. Tasks include:\n1) Researching and listing five best practices for securing a web server.\n2) Setting up and testing a basic firewall rule on a local system.\n3) Checking if the Visa Processing Site is using HTTPS and understanding its importance.\n4) Identifying common network vulnerabilities and suggesting solutions.\n5) Documenting security recommendations for improving network protection."
        }
      ],
      "coursename": "Cyber Network Security"
    },


    {
      "id": 6,
      "html_title": "Cybersecurity Internship - Day 6",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Web Server Security and Hardening",
          "bootstrap_title_desc": "Web server security is essential for preventing attacks on the Visa Processing Site. Key security practices include:\n\n1) Disabling unnecessary services to reduce attack surface.\n2) Enforcing strong authentication methods for admin access.\n3) Configuring security headers (Content Security Policy, X-Frame-Options, etc.).\n4) Regularly updating and patching the server OS and web server software.\n5) Implementing logging and monitoring to detect suspicious activity."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 6",
          "bootstrap_title_desc": "On the sixth day, interns will focus on securing the web server hosting the Visa Processing Site. Follow these steps:\n\n1) **Research and List Security Best Practices**\n   - Identify and document five key security measures for web servers.\n\n2) **Check Server Software and Update**\n   - Verify if the web server (e.g., Apache, Nginx) and OS are up to date.\n   - Research how to update the web server safely.\n\n3) **Configure Security Headers**\n   - Use browser developer tools (F12 -> Network -> Headers) to check if security headers like Content-Security-Policy and X-Frame-Options are present.\n   - Research how to add missing security headers.\n\n4) **Set Up Basic Logging & Monitoring**\n   - Enable logging for tracking unauthorized access attempts.\n   - Research how to use log analysis tools to detect potential attacks.\n\n5) **Document Findings and Fixes**\n   - Prepare a brief report detailing the security issues found, the steps taken to fix them, and recommendations for further improvement."
        }
      ],
      "coursename": "Web Security Essentials"
    },


    {
      "id": 7,
      "html_title": "Cybersecurity Internship - Day 7",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Database Security Fundamentals",
          "bootstrap_title_desc": "Securing databases is critical for protecting sensitive information on the Visa Processing Site. Key security practices include:\n\n1) Using strong authentication and role-based access control.\n2) Encrypting sensitive data stored in the database.\n3) Preventing SQL Injection attacks through prepared statements.\n4) Regularly backing up data and implementing recovery plans.\n5) Monitoring database activity for suspicious queries."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 7",
          "bootstrap_title_desc": "On the seventh day, interns will focus on improving database security. Follow these steps:\n\n1) **Analyze User Access Control**\n   - Check the database user roles and permissions.\n   - Ensure that no user has unnecessary privileges.\n\n2) **Secure Database Authentication**\n   - Verify that strong passwords are used for database access.\n   - Research and implement multi-factor authentication (MFA) if applicable.\n\n3) **Prevent SQL Injection**\n   - Identify any direct SQL queries in the Visa Processing Site.\n   - Replace them with prepared statements or parameterized queries.\n\n4) **Encrypt Sensitive Data**\n   - Research methods to encrypt stored passwords, personal details, and financial information.\n   - Implement encryption where necessary.\n\n5) **Monitor and Backup the Database**\n   - Enable database logging to track unauthorized or suspicious queries.\n   - Set up an automated backup system and document the process.\n\n6) **Document Findings and Fixes**\n   - Prepare a report detailing the database security issues found, the steps taken to fix them, and recommendations for improvement."
        }
      ],
      "coursename": "Web Security fundamentals"
    },

    {
      "id": 8,
      "html_title": "Cybersecurity Internship - Day 8",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "API Security and Protection",
          "bootstrap_title_desc": "Securing APIs is essential for protecting data exchanges in the Visa Processing Site. Key security practices include:\n\n1) Using authentication mechanisms like API keys, OAuth, or JWT.\n2) Validating and sanitizing all incoming API requests.\n3) Implementing rate limiting to prevent abuse and DDoS attacks.\n4) Encrypting API responses and sensitive data in transit.\n5) Logging API activity and monitoring for anomalies."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 8",
          "bootstrap_title_desc": "On the eighth day, interns will work on strengthening API security. Follow these steps:\n\n1) **Analyze API Authentication**\n   - Check how APIs in the Visa Processing Site authenticate users.\n   - Implement JWT (JSON Web Token) authentication if not already in place.\n\n2) **Validate API Inputs**\n   - Identify all API endpoints that accept user input.\n   - Implement validation to prevent injection attacks and improper data submission.\n\n3) **Set Up Rate Limiting**\n   - Research how rate limiting works in web applications.\n   - Implement basic rate limiting to prevent excessive API requests.\n\n4) **Encrypt Data in Transit**\n   - Ensure APIs use HTTPS for secure communication.\n   - Research how to encrypt API responses containing sensitive data.\n\n5) **Monitor API Activity**\n   - Enable logging for all API calls.\n   - Identify any suspicious API requests and document findings.\n\n6) **Document Findings and Fixes**\n   - Prepare a report detailing API security vulnerabilities, the fixes applied, and best practices for future improvements."
        }
      ],
      "coursename": "Web Security protection"
    },



    {
      "id": 9,
      "html_title": "Cybersecurity Internship - Day 9",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Web Application Penetration Testing",
          "bootstrap_title_desc": "Penetration testing helps identify vulnerabilities in the Visa Processing Site. Key testing techniques include:\n\n1) Scanning the web application for vulnerabilities.\n2) Performing SQL Injection and Cross-Site Scripting (XSS) tests.\n3) Checking authentication and session management weaknesses.\n4) Testing file upload security to prevent malicious uploads.\n5) Conducting a report on identified risks and mitigation strategies."
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 9",
          "bootstrap_title_desc": "On the ninth day, interns will practice basic penetration testing on the Visa Processing Site. Follow these steps:\n\n1) **Set Up a Testing Environment**\n   - Use a local setup or a controlled environment for testing.\n   - Install security testing tools like OWASP ZAP or Burp Suite.\n\n2) **Scan for Vulnerabilities**\n   - Perform an automated scan using OWASP ZAP/Burp Suite.\n   - Identify vulnerabilities such as outdated libraries and weak authentication.\n\n3) **Test for SQL Injection**\n   - Find input fields that interact with the database.\n   - Attempt SQL Injection attacks using test payloads.\n   - Verify if input validation is properly implemented.\n\n4) **Check for XSS Vulnerabilities**\n   - Test input fields for Cross-Site Scripting by injecting JavaScript.\n   - Ensure proper escaping and sanitization of inputs.\n\n5) **Assess Authentication and Session Management**\n   - Try session hijacking and weak password attacks.\n   - Evaluate password reset and login mechanisms.\n\n6) **Test File Upload Security**\n   - If the application allows file uploads, test for unauthorized file types.\n   - Verify if uploaded files are sanitized and restricted.\n\n7) **Document Findings and Fixes**\n   - Prepare a report detailing vulnerabilities found, risk levels, and recommended fixes."
        }
      ],
      "coursename": "Web Security Testing"
    },

    {
      "id": 10,
      "html_title": "Cybersecurity Internship - Day 10",
      "bootstrap_head_desc": [
        {
          "bootstrap_title_heading": "Incident Response and Handling",
          "bootstrap_title_desc": `Incident response is crucial for minimizing the impact of cyber attacks on the Visa Processing Site. Key response steps include:
    1) Identifying security incidents and categorizing threats.
    2) Containing the attack to prevent further damage.
    3) Investigating the root cause and affected systems.
    4) Eradicating the threat by applying security fixes.
    5) Recovering compromised systems and ensuring normal operations.
    6) Documenting the incident for future prevention and improvements.
          `
        },
        {
          "bootstrap_title_heading": "Internship Task - Day 10",
          "bootstrap_title_desc": `On the tenth day, interns will simulate an incident response scenario for the Visa Processing Site. Follow these steps:
    1) **Identify a Security Incident**
       - Research common cyber threats (e.g., malware, phishing, data breaches).
       - Choose one scenario and describe how it could impact the Visa Processing Site.
    
    2) **Contain the Threat**
       - List immediate actions to isolate the affected system.
       - Suggest ways to prevent the attack from spreading.
    
    3) **Investigate the Incident**
       - Analyze logs to detect suspicious activities.
       - Identify the entry point and nature of the attack.
    
    4) **Eradicate the Threat**
       - Research how to remove malware or fix vulnerabilities.
       - Apply necessary security patches or configuration changes.
    
    5) **Recover the System**
       - Restore affected systems using backups.
       - Ensure security controls are in place before bringing systems back online.
    
    6) **Document the Incident**
       - Write a report outlining the incident, response steps, and lessons learned.
    `
        }
      ],
      "coursename": "Cyber Incident Management"
    },



    
    {
  "id": 11,
  "html_title": "Cybersecurity Internship - Day 11",
  "bootstrap_head_desc": [
    {
      "bootstrap_title_heading": "Secure Coding Practices",
      "bootstrap_title_desc": `Writing secure code is essential for preventing vulnerabilities in the Visa Processing Site. Key secure coding principles include:


1) Input validation to prevent injection attacks.
2) Using parameterized queries to avoid SQL Injection.
3) Encrypting sensitive user data.
4) Implementing proper authentication and authorization.
5) Avoiding hardcoded credentials in the codebase.
6) Regularly updating dependencies to fix security flaws.
`
    },
    {
      "bootstrap_title_heading": "Internship Task - Day 11",
      "bootstrap_title_desc": `On the eleventh day, interns will focus on implementing secure coding practices. Follow these steps:


1) **Review Existing Code for Security Issues**
   - Check for hardcoded credentials or API keys.
   - Identify areas where user input is not properly validated.

2) **Implement Secure Input Validation**
   - Use libraries to validate user input (e.g., express-validator for Node.js, Django forms for Python).
   - Ensure special characters are sanitized to prevent XSS and SQL Injection.

3) **Secure Authentication and Authorization**
   - Implement role-based access control (RBAC).
   - Use secure password hashing methods (bcrypt, Argon2).

4) **Encrypt Sensitive Data**
   - Ensure sensitive information (e.g., passwords, financial data) is stored using encryption.
   - Use HTTPS for secure data transmission.

5) **Remove Unused and Insecure Dependencies**
   - Run dependency checks using npm audit (Node.js) or pip-audit (Python).
   - Update outdated libraries to patch security vulnerabilities.

6) **Document Security Improvements**
   - Create a report listing the security enhancements made.
   - Include code snippets before and after applying secure coding practices.
`
    }
  ],
  "coursename": "Secure Software Development"
},


{
  "id": 12,
  "html_title": "Cybersecurity Internship - Day 12",
  "bootstrap_head_desc": [
    {
      "bootstrap_title_heading": "Important Security Testing Tools",
      "bootstrap_title_desc": "Understanding security tools is crucial for effectively testing and securing the Visa Processing Site. Today, we focus on two key tools:\n\n```\n1) **Burp Suite** - A powerful tool for penetration testing and web security assessment.\n2) **OWASP ZAP** - An open-source security scanner designed to find vulnerabilities in web applications.\n```"
    },
    {
      "bootstrap_title_heading": "Burp Suite - Introduction & Installation",
      "bootstrap_title_desc": "Burp Suite is widely used by cybersecurity professionals for testing web applications. Follow these steps to install and set it up:\n\n```\n1) **Download Burp Suite**\n   - Visit the official website: https://portswigger.net/burp.\n   - Choose the Community or Professional edition based on requirements.\n\n2) **Install Burp Suite**\n   - Follow installation steps based on your OS (Windows, macOS, Linux).\n   - Launch Burp Suite and configure browser proxy settings.\n\n3) **Intercept HTTP Requests**\n   - Open the Proxy tab and enable Intercept mode.\n   - Configure your browser to route traffic through Burp Suite's proxy.\n\n4) **Perform Basic Security Testing**\n   - Capture and modify requests to test for vulnerabilities.\n   - Use the Scanner tool to detect security issues automatically.\n```"
    },
    {
      "bootstrap_title_heading": "Internship Task - Day 12",
      "bootstrap_title_desc": "On the twelfth day, interns will install and explore Burp Suite. Follow these steps:\n\n```\n1) **Install and Launch Burp Suite**\n   - Follow the installation guide and set up the proxy.\n\n2) **Intercept and Analyze Requests**\n   - Open a web application and monitor HTTP requests in Burp Suite.\n   - Identify sensitive data being transmitted.\n\n3) **Perform a Basic Security Scan**\n   - Use the built-in Scanner tool to find vulnerabilities.\n   - Document any security weaknesses detected.\n\n4) **Submit a Security Report**\n   - Capture screenshots of intercepted requests.\n   - Explain the security flaws found and suggest fixes.\n```"
    }
  ],
  "coursename": "Burp Suite"
},


{
  "id": 14,
  "html_title": "Cybersecurity Internship - Day 14",
  "bootstrap_head_desc": [
    {
      "bootstrap_title_heading": "Splunk - Security Information and Event Management (SIEM)",
      "bootstrap_title_desc": `Splunk is a powerful tool used for Security Information and Event Management (SIEM). It helps in monitoring, analyzing, and visualizing security threats in real time. Follow these steps to understand and use Splunk:
      
1) **Download and Install Splunk**
   - Visit the official website: https://www.splunk.com/en_us/download.html.
   - Choose Splunk Enterprise (Free Trial) or Splunk Cloud.
   - Install Splunk on Windows/Linux and set up the Splunk web interface.
      
2) **Understanding Splunk Interface**
   - Explore the Dashboard, Search & Reporting, and Data Inputs sections.
   - Learn how to configure log sources and set up monitoring for security events.
      
3) **Ingesting Security Logs**
   - Collect logs from system files, firewalls, and applications.
   - Use Splunk’s Universal Forwarder to ingest log data in real time.
      
4) **Searching and Analyzing Logs**
   - Use Splunk Search Processing Language (SPL) to query security logs.
   - Identify security threats such as brute-force attacks, failed logins, and malware infections.
      
5) **Creating Security Dashboards**
   - Build real-time dashboards to visualize security threats.
   - Configure alerts to notify administrators about suspicious activities.
      
6) **Generating Incident Reports**
   - Export security reports based on detected threats.
   - Provide recommendations for improving security posture.`
    },
    {
      "bootstrap_title_heading": "Internship Task - Day 14",
      "bootstrap_title_desc": `On the fourteenth day, interns will work with Splunk for security monitoring. Follow these steps:
      
1) **Install and Set Up Splunk**
   - Follow the installation guide and configure data sources.
      
2) **Ingest Security Logs**
   - Collect and index logs from system files, firewalls, and applications.
      
3) **Search for Security Threats**
   - Use SPL queries to find failed login attempts and brute-force attacks.
      
4) **Create a Security Dashboard**
   - Build a dashboard displaying real-time security events.
      
5) **Generate and Submit a Security Report**
   - Analyze threats and document mitigation steps.`
    }
  ],
  "coursename": "Splunk"
},






    
    
    
    
    
    
  
  
 

    {
      "id": 6,
  
  
      "html_title": "cyber tools",
  
  
      "bootstrap_head_desc": [
     


        {
          "bootstrap_title_heading": "sectools",
          
         
  
          
          
          "bootstrap_title_desc": `burp suit
          
. Here are some key reasons why Burp Suite is commonly used:


Burp Suite is a widely used application security testing tool that serves various purposes in the field of cybersecurity. Here are some key reasons why Burp Suite is commonly used:

Web Application Security Testing:

Burp Suite is designed for finding security vulnerabilities in web applications.

Manual Testing and Analysis:

Security professionals use Burp Suite to manually analyze and manipulate HTTP requests and responses. 

Automated Scanning:

Burp Suite includes automated scanning features that can crawl a web application and identify common security issues, such as SQL injection, 

Session Management:

The tool assists in managing and manipulating user sessions. Security professionals can use Burp Suite to capture, analyze, and modify session tokens, cookies, and other session-related data.

Security Research and Learning:

Burp Suite is a valuable tool for security researchers and students learning about web application security.

Proxy Capabilities:

Burp Suite acts as a proxy between the user's browser and the target web application. This allows testers to intercept and modify requests and responses in real-time,

`,
        },

        {
          "bootstrap_title_heading": "installation",
          
         
  
          
          
          "bootstrap_title_desc": `Step 1: Install Burp Suite
Download Burp Suite: Visit the official Burp Suite website and
download the appropriate version (Community or Professional) for your operating system.

Step 2: Explore the User Interface
Open Burp Suite: Launch Burp Suite after installation.

Explore the Tabs:

Target: Set the target scope for your testing.
Proxy: Intercept and modify HTTP requests.
Spider: Crawl and map the target application.
Scanner: Automatically identify security vulnerabilities.
Intruder: Perform automated attacks.
Repeater: Manually repeat and modify requests.
Decoder: Decode/encode data.
Comparer: Compare responses.
Extender: Use extensions to customize Burp Suite.

Step 3: Configure Browser and Burp Proxy
Configure Browser Proxy:

Set your browser to use Burp Suite as a proxy. Change the proxy settings in your browser to 127.0.0.1 and port 8080 (default).
Verify Proxy Connection:

Check that Burp Suite is intercepting requests in the "Proxy" tab.


Step 4: Practice Interception
Intercept Requests:
Use the "Intercept" toggle in the "Proxy" tab to intercept requests.
Observe and modify HTTP requests before forwarding them.

Step 5: Explore Target Tab
Add Target:
Navigate to the "Target" tab and add the target URL of the web application you want to test.

Step 6: Use Spider
Start Spider:
In the "Spider" tab, start the spider to crawl the target application.
Review the results in the "Site map."

Step 7: Automated Scanning with Scanner
Run Scanner:
In the "Scanner" tab, initiate an automated scan to identify common vulnerabilities.

Step 8: Intruder for Manual Testing
Use Intruder:
In the "Intruder" tab, perform manual attacks by customizing and automating requests.
Explore payload options for fuzzing.

Step 9: Repeater for Manual Testing
Use Repeater:
In the "Repeater" tab, manually send and modify requests to observe their impact.

tep 10: Learn Decoder, Comparer, and Extender
Explore Other Tabs:

Familiarize yourself with the "Decoder," "Comparer," and "Extender" tabs for various tasks.
Learn Extensions:

Explore Burp Suite extensions to enhance functionality.

Step 11: Review and Analyze
Analyze Results:
Review the findings, logs, and reports generated by Burp Suite.
Understand security vulnerabilities and their impact.

Step 12: Explore Burp Suite Documentation
Read Documentation:
Refer to the 'official Burp Suite documentation' for in-depth explanations and tutorials.

`,
        },

        {
          "bootstrap_title_heading": "take steps",
          
         
  
          
          
          "bootstrap_title_desc": `Step 1: Start Burp Suite
Open Burp Suite and make sure it's running.

Step 2: Configure Browser Proxy
Open your browser settings.
Configure the proxy settings to use Burp Suite:
Host: 127.0.0.1
Port: 8080 (default)
Step 3: Intercept a Request
In Burp Suite, go to the "Proxy" tab.
Ensure the "Intercept" toggle is on (should be green).
Go to your browser and visit any website (e.g., http://example.com).
You'll notice that Burp Suite intercepts the request in the "Proxy" tab.

Step 4: Forward the Request
In Burp Suite, go to the "Proxy" tab.
You'll see the intercepted request. Right-click on it and select "Forward" to send it to the server.
Step 5: Modify the Request
In Burp Suite, go to the "Proxy" tab.
Intercept a request.
Right-click on the request and select "Send to Repeater."
In the "Repeater" tab, you can modify the request's parameters or body.
Click "Go" to send the modified request.
Step 6: Analyze Responses
In Burp Suite, go to the "Proxy" tab.
Intercept a response.
Analyze the response in the "Response" tab. You can see the server's response.
Step 7: Spider a Website
Go to the "Target" tab.
Enter a target URL (e.g., http://example.com).
Right-click on the target and select "Spider this host."
Review the results in the "Site map."
Step 8: Automated Scanning
Go to the "Target" tab.
Right-click on the target and select "Scan."`,
        },
      




  

        
      
  
  
      
      ],
  
  
  
  
  
  
  
  
  
  
  
  
      "coursename": "cyber tools",
  
  
    },
  
  
   
  

   
   
  
  
  
  
  
  
  
  
  
  
  ]
  export default CyberJson